import { render, staticRenderFns } from "./ContactFiles.vue?vue&type=template&id=56fb6aac&scoped=true"
import script from "./ContactFiles.vue?vue&type=script&lang=js"
export * from "./ContactFiles.vue?vue&type=script&lang=js"
import style0 from "./ContactFiles.vue?vue&type=style&index=0&id=56fb6aac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fb6aac",
  null
  
)

export default component.exports